namespace GeniuzPOS.ReportMasterData {
    export class Report_1102Columns {
        static columnsKey = 'ReportMasterData.Report_1102';
    }
}
